/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 15.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../../../DataProvider";
import DataWidget from "../../../../components/DataWidget";

class DataView extends React.Component {

    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderItems() {
        let items = [];
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider;
        let fieldList = dataProvider.getSchema().getFieldList();
        for (let field of fieldList) {
            let title = dataProvider.getSchema().field(field).getTitle();
            if (dataProvider.getValue(field) == null) continue;
            items.push((<dt key={field+"-dt"}>{title + ":"}</dt>));
            items.push((<dd key={field+"-dd"}><DataWidget dataProvider={dataProvider} field={field} /></dd>));
        }
        return items;
    }

    render() {
        if (!this.props.dataProvider.getValue()) return null;
        return (
            <dl className="dl-horizontal">
                {this.renderItems()}
            </dl>
        );
    }
}

export default DataView;
